export default __webpack_public_path__ + "static/media/OSM.6353e4d4.jpg";